<div class="catering-summary-widget">
  @if (showPdfDownload && !isLoading && data) {
  <div class="widget-toolbar">
    <button
      mat-stroked-button
      type="button"
      class="pdf-btn"
      (click)="onDownloadPdf()"
      title="Download PDF"
    >
      <mat-icon>picture_as_pdf</mat-icon>
      Download PDF
    </button>
  </div>
  }
  @if (isLoading) {
  <div class="widget-loading">
    <div class="loading-spinner-small"></div>
    <p>Indlæser forplejningsdata...</p>
  </div>
  } @if (!isLoading) { @if (data?.period) {
  <div class="period-summary">
    Periode: {{ data!.period.start }} – {{ data!.period.end }} ({{
      data!.period.days
    }}
    {{ data!.period.days === 1 ? "dag" : "dage" }})
  </div>
  } @if
  (getPreferenceKeys($safeNavigationMigration(data?.totals?.preferences)).length
  > 0 || (data?.totals?.extras?.length || 0) > 0) {
  <div class="summary-section">
    <h4>Total bestilling</h4>
    <div class="summary-chips">
      @for (key of
      getPreferenceKeys($safeNavigationMigration(data?.totals?.preferences));
      track key) {
      <span class="summary-chip">
        <span class="chip-count">{{ preferenceCount(data!.totals.preferences, key) }}</span>
        {{ preferenceLabel(key) }}
      </span>
      } @for (extra of data?.totals?.extras || []; track extra) {
      <span class="summary-chip extra-chip">
        <span class="chip-count">{{ extra.quantity }}</span>
        {{ extra.label }}
      </span>
      }
    </div>
  </div>
  } @if (data?.days?.length) {
  <div class="days-grid">
    @for (day of data!.days; track day) {
    <div class="day-card">
      <div class="day-card-header">
        <div class="day-title">{{ formatDayDate(day.date) }}</div>
        <div class="day-meta">{{ day.events.length }} event(s)</div>
      </div>
      @if
      (getPreferenceKeys($safeNavigationMigration(day.totals?.preferences)).length
      > 0 || (day.totals?.extras?.length || 0) > 0) {
      <div class="day-totals summary-chips">
        @for (key of
        getPreferenceKeys($safeNavigationMigration(day.totals?.preferences));
        track key) {
        <span class="summary-chip">
          <span class="chip-count">{{ preferenceCount(day.totals.preferences, key) }}</span>
          {{ preferenceLabel(key) }}
        </span>
        } @for (extra of day.totals?.extras || []; track extra) {
        <span class="summary-chip extra-chip">
          <span class="chip-count">{{ extra.quantity }}</span>
          {{ extra.label }}
        </span>
        }
      </div>
      }
      <div class="day-events">
        @for (event of day.events; track event) {
        <div class="event-card">
          <div class="event-card-header">
            <div class="event-title-block">
              <div class="event-name">{{ event.event_name || "Event" }}</div>
              <span
                class="approval-badge"
                [class]="'approval-' + approvalColor(event.approval_status)"
              >
                {{ approvalLabel(event.approval_status) }}
              </span>
            </div>
            <div class="event-actions">
              @if (allowEventNavigation) {
              <button
                mat-icon-button
                title="Åbn event"
                (click)="onNavigateToEvent(event.guid)"
              >
                <mat-icon>open_in_new</mat-icon>
              </button>
              }
              <button
                mat-stroked-button
                color="primary"
                class="wishes-btn"
                (click)="onOpenPreferences(event)"
              >
                <mat-icon>restaurant</mat-icon>
                Forplejningsønsker
              </button>
            </div>
          </div>
          <div class="event-details">
            @if (event.location) {
            <div class="detail-row">
              <mat-icon>place</mat-icon>
              <span>{{ event.location }}</span>
            </div>
            }
            <div class="detail-row">
              <mat-icon>meeting_room</mat-icon>
              <span>Lokale: {{ event.event_room || "—" }}</span>
            </div>
            <div class="detail-row">
              <mat-icon>restaurant</mat-icon>
              <span
                >Forplejning i:
                {{ event.catering_room_name || "Standardlokale" }}</span
              >
            </div>
            <div class="detail-row">
              <mat-icon>schedule</mat-icon>
              <span>{{ formatEventTime(event) }}</span>
            </div>
            <div class="detail-row">
              <mat-icon>groups</mat-icon>
              <span>{{ participantCount(event) }} deltagere</span>
            </div>
            @if (event.customer_name) {
            <div class="detail-row">
              <mat-icon>business</mat-icon>
              <span>{{ event.customer_name }}</span>
            </div>
            }
          </div>
          @if (getPreferenceKeys(event.preferences).length > 0 ||
          (event.extras?.length || 0) > 0) {
          <div class="event-summary summary-chips">
            @for (key of getPreferenceKeys(event.preferences); track key) {
            <span class="summary-chip">
              <span class="chip-count">{{ preferenceCount(event.preferences, key) }}</span>
              {{ preferenceLabel(key) }}
            </span>
            } @for (extra of event.extras || []; track extra) {
            <span class="summary-chip extra-chip">
              <span class="chip-count">{{ extra.quantity }}</span>
              <span class="chip-label">
                {{ extra.label }}
                @if (extra.comment) {
                <span class="chip-comment"> — {{ extra.comment }}</span>
                }
              </span>
            </span>
            }
          </div>
          } @if (event.catering_order_comment) {
          <div class="order-comment">
            <strong>Kommentar til ordren:</strong>
            <p>{{ event.catering_order_comment }}</p>
          </div>
          }
        </div>
        }
      </div>
    </div>
    }
  </div>
  } @else {
  <div class="empty-state">
    <mat-icon>restaurant</mat-icon>
    <p>Ingen forplejningsevents i den valgte periode</p>
  </div>
  } }
</div>
